import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/img/rule_title.png'


const _hoisted_1 = { class: "page-rule" }
const _hoisted_2 = { class: "rule-inner" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "rule-title" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1)
const _hoisted_4 = { class: "rule-container" }
const _hoisted_5 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", {
          class: "rule-content",
          innerHTML: _ctx.activityData.templateConfig.desc
        }, null, 8, _hoisted_5)
      ])
    ])
  ]))
}